import {Collection} from "vue-mc"
import bookingAvailableModel from "../models/bookingAvailableModel";

export default class bookingAvailableCollection extends Collection {

    model() {
        return bookingAvailableModel;
    }

    routes() {
        return {
            fetch: 'interpreter/jobs/available/'
        }
    }
}
